module.exports = __webpack_public_path__ + "img/warner-media.dfcc9362.svg";